import React from 'react';
import { connect } from 'react-redux';
import FormElement from 'components/FormElement';
import CyberComponent from 'containers/CyberComponent';
import { handleInputChange, cleanBillingPocInfo } from 'actions/request';
import {
  formatPocList,
  renderSelectedPocInfo,
  onSelectPoc
} from 'helpers/BillingHelper';

class BillingPocSelector extends CyberComponent {
  render() {
    const {
      show,
      request,
      user,
      toggleSelector,
      handleInputChange
    } = this.props;

    if (!show) return null;

    const isEditable = user.canEditRequest && !request.isPaid;

    if (request.pocs) {
      return (
        <div>
          <FormElement
            type="select"
            id="billingPocId"
            label="Billing PoC"
            value={request.billingPocId}
            onChange={onSelectPoc.bind(
              this,
              toggleSelector,
              handleInputChange,
              cleanBillingPocInfo
            )}
            options={formatPocList(request.pocs)}
            editable={isEditable}
          />
          {renderSelectedPocInfo(request)}
        </div>
      );
    }
    return null;
  }
}

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    cleanBillingPocInfo
  }
)(BillingPocSelector);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/BillingPocSelector.js